import React, { useState, FormEvent, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Checkbox, Tooltip } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form'

import svgWait2 from './svg/wait2.gif'


import { SLSetupInfo } from './Types'
import { SystemHeader } from './CommonUI';

import { transpileModule } from 'typescript';
import { stringify } from 'querystring';


interface PageInfo {
    n: number
}

var GsbFlag: any;

interface SLSetupViewProps {
    gsb: AxiosInstance,
    SLSetup: SLSetupInfo,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
}



function SLSetupView({ gsb, SLSetup = {} as SLSetupInfo, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { } }: SLSetupViewProps) {

    const [isDeletePress, setisDeletePress] = useState(false)


    if (! ("x_MAIN_LCN1" in SLSetup)) return null



    return (
        <div>
            <div className="Row">
                <Button className="Col-1-1" disabled={true} icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                <Button className="Col-2-1" disabled={true} icon="add" onClick={() => onNew()} >New</Button>
                <Button className="Col-3-1" icon="edit" onClick={() => onEdit()} >Edit</Button>
                <Button className="Col-4-1" disabled={true} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>

                <Button className="Col-5-1" disabled={true} icon="direction-right" onClick={() => onNextRec()} >Next</Button>
             
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 1">
                    <InputGroup readOnly value={SLSetup.x_MAIN_LCN1} />
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN1"
                        disabled={true}
                        inline={true}
                        selectedValue={SLSetup.x_STD_MGN1}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 2">
                    <InputGroup readOnly value={SLSetup.x_MAIN_LCN2} />
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN2"
                        disabled={true}
                        inline={true}
                        selectedValue={SLSetup.x_STD_MGN2}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 3">
                    <InputGroup readOnly value={SLSetup.x_MAIN_LCN3} />
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN3"
                        disabled={true}
                        inline={true}
                        selectedValue={SLSetup.x_STD_MGN3}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 4">
                    <InputGroup readOnly value={SLSetup.x_MAIN_LCN4} />
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN4"
                        disabled={true}
                        inline={true}
                        selectedValue={SLSetup.x_STD_MGN4}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 5">
                    <InputGroup readOnly value={SLSetup.x_MAIN_LCN5} />
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN5"
                        disabled={true}
                        inline={true}
                        selectedValue={SLSetup.x_STD_MGN5}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 6">
                    <InputGroup readOnly value={SLSetup.x_MAIN_LCN6} />
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN6"
                        disabled={true}
                        inline={true}
                        selectedValue={SLSetup.x_STD_MGN6}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 7">
                    <InputGroup readOnly value={SLSetup.x_MAIN_LCN7} />
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN7"
                        disabled={true}
                        inline={true}
                        selectedValue={SLSetup.x_STD_MGN7}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 8">
                    <InputGroup readOnly value={SLSetup.x_MAIN_LCN8} />
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN8"
                        disabled={true}
                        inline={true}
                        selectedValue={SLSetup.x_STD_MGN8}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 9">
                    <InputGroup readOnly value={SLSetup.x_MAIN_LCN9} />
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN9"
                        disabled={true}
                        inline={true}
                        selectedValue={SLSetup.x_STD_MGN9}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 10">
                    <InputGroup readOnly value={SLSetup.x_MAIN_LCN10} />
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN10"
                        disabled={true}
                        inline={true}
                        selectedValue={SLSetup.x_STD_MGN10}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            { (GsbFlag.LONG_BKMGN) && <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 11">
                    <InputGroup readOnly value={SLSetup.x_MAIN_LCN11} />
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN11"
                        disabled={true}
                        inline={true}
                        selectedValue={SLSetup.x_STD_MGN11}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div> }
            { (GsbFlag.LONG_BKMGN) && <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 12">
                    <InputGroup readOnly value={SLSetup.x_MAIN_LCN12} />
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN12"
                        disabled={true}
                        inline={true}
                        selectedValue={SLSetup.x_STD_MGN12}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div> }
            { (GsbFlag.LONG_BKMGN) && <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 13">
                    <InputGroup readOnly value={SLSetup.x_MAIN_LCN13} />
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN13"
                        disabled={true}
                        inline={true}
                        selectedValue={SLSetup.x_STD_MGN13}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div> }
            { (GsbFlag.LONG_BKMGN) && <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 14">
                    <InputGroup readOnly value={SLSetup.x_MAIN_LCN14} />
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN14"
                        disabled={true}
                        inline={true}
                        selectedValue={SLSetup.x_STD_MGN14}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div> }
            { (GsbFlag.LONG_BKMGN) && <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 15">
                    <InputGroup readOnly value={SLSetup.x_MAIN_LCN15} />
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN15"
                        disabled={true}
                        inline={true}
                        selectedValue={SLSetup.x_STD_MGN15}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div> }
            <div className="Spacing-V-16" />
        </div>
    )
}

interface SLSetupEditProps {
    gsb: AxiosInstance,
    SLSetup?: SLSetupInfo,
    isNew?: boolean,
    onSave?: (SLSetup: SLSetupInfo) => void,
    onCancel?: () => void;
}

// onChange={utils.handleStringChange(s => setAc(prevState => Object.assign(prevState, {acName1: s})))}
function SLSetupEdit({ gsb, SLSetup = {} as SLSetupInfo, isNew = false, onSave = () => { }, onCancel = () => { } }: SLSetupEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<SLSetupInfo>()

    const [MAIN_LCN1Value, setMAIN_LCN1Value] = useState(SLSetup.x_MAIN_LCN1)
    const [MAIN_LCN2Value, setMAIN_LCN2Value] = useState(SLSetup.x_MAIN_LCN2)
    const [MAIN_LCN3Value, setMAIN_LCN3Value] = useState(SLSetup.x_MAIN_LCN3)
    const [MAIN_LCN4Value, setMAIN_LCN4Value] = useState(SLSetup.x_MAIN_LCN4)
    const [MAIN_LCN5Value, setMAIN_LCN5Value] = useState(SLSetup.x_MAIN_LCN5)
    const [MAIN_LCN6Value, setMAIN_LCN6Value] = useState(SLSetup.x_MAIN_LCN6)
    const [MAIN_LCN7Value, setMAIN_LCN7Value] = useState(SLSetup.x_MAIN_LCN7)
    const [MAIN_LCN8Value, setMAIN_LCN8Value] = useState(SLSetup.x_MAIN_LCN8)
    const [MAIN_LCN9Value, setMAIN_LCN9Value] = useState(SLSetup.x_MAIN_LCN9)
    const [MAIN_LCN10Value, setMAIN_LCN10Value] = useState(SLSetup.x_MAIN_LCN10)
    const [MAIN_LCN11Value, setMAIN_LCN11Value] = useState(SLSetup.x_MAIN_LCN11)
    const [MAIN_LCN12Value, setMAIN_LCN12Value] = useState(SLSetup.x_MAIN_LCN12)
    const [MAIN_LCN13Value, setMAIN_LCN13Value] = useState(SLSetup.x_MAIN_LCN13)
    const [MAIN_LCN14Value, setMAIN_LCN14Value] = useState(SLSetup.x_MAIN_LCN14)
    const [MAIN_LCN15Value, setMAIN_LCN15Value] = useState(SLSetup.x_MAIN_LCN15)

    const [STD_MGN1Value, setSTD_MGN1Value] = useState(SLSetup.x_STD_MGN1)
    const [STD_MGN2Value, setSTD_MGN2Value] = useState(SLSetup.x_STD_MGN2)
    const [STD_MGN3Value, setSTD_MGN3Value] = useState(SLSetup.x_STD_MGN3)
    const [STD_MGN4Value, setSTD_MGN4Value] = useState(SLSetup.x_STD_MGN4)
    const [STD_MGN5Value, setSTD_MGN5Value] = useState(SLSetup.x_STD_MGN5)
    const [STD_MGN6Value, setSTD_MGN6Value] = useState(SLSetup.x_STD_MGN6)
    const [STD_MGN7Value, setSTD_MGN7Value] = useState(SLSetup.x_STD_MGN7)
    const [STD_MGN8Value, setSTD_MGN8Value] = useState(SLSetup.x_STD_MGN8)
    const [STD_MGN9Value, setSTD_MGN9Value] = useState(SLSetup.x_STD_MGN9)
    const [STD_MGN10Value, setSTD_MGN10Value] = useState(SLSetup.x_STD_MGN10)
    const [STD_MGN11Value, setSTD_MGN11Value] = useState(SLSetup.x_STD_MGN11)
    const [STD_MGN12Value, setSTD_MGN12Value] = useState(SLSetup.x_STD_MGN12)
    const [STD_MGN13Value, setSTD_MGN13Value] = useState(SLSetup.x_STD_MGN13)
    const [STD_MGN14Value, setSTD_MGN14Value] = useState(SLSetup.x_STD_MGN14)
    const [STD_MGN15Value, setSTD_MGN15Value] = useState(SLSetup.x_STD_MGN15)

    useEffect(() => {
        // Call reset to set default values if ac is passed
        if ("x_MAIN_LCN1" in SLSetup) {
            reset(SLSetup)
        }
    }, [SLSetup, reset])

    
    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it manually and call setValue when item is selected
        //register({ name: "d_status" })
    }, [register])

    
    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])
    
    

    if (! isNew && !("x_MAIN_LCN1" in SLSetup)) return null


    const onSubmit = (data: SLSetupInfo) => {
        //console.log("onsubmit called", data)

        data.x_MAIN_LCN1 = MAIN_LCN1Value;
        data.x_MAIN_LCN2 = MAIN_LCN2Value;
        data.x_MAIN_LCN3 = MAIN_LCN3Value;
        data.x_MAIN_LCN4 = MAIN_LCN4Value;
        data.x_MAIN_LCN5 = MAIN_LCN5Value;
        data.x_MAIN_LCN6 = MAIN_LCN6Value;
        data.x_MAIN_LCN7 = MAIN_LCN7Value;
        data.x_MAIN_LCN8 = MAIN_LCN8Value;
        data.x_MAIN_LCN9 = MAIN_LCN9Value;
        data.x_MAIN_LCN10 = MAIN_LCN10Value;
        data.x_MAIN_LCN11 = MAIN_LCN11Value;
        data.x_MAIN_LCN12 = MAIN_LCN12Value;
        data.x_MAIN_LCN13 = MAIN_LCN13Value;
        data.x_MAIN_LCN14 = MAIN_LCN14Value;
        data.x_MAIN_LCN15 = MAIN_LCN15Value;

        data.x_STD_MGN1 = STD_MGN1Value;
        data.x_STD_MGN2 = STD_MGN2Value;
        data.x_STD_MGN3 = STD_MGN3Value;
        data.x_STD_MGN4 = STD_MGN4Value;
        data.x_STD_MGN5 = STD_MGN5Value;
        data.x_STD_MGN6 = STD_MGN6Value;
        data.x_STD_MGN7 = STD_MGN7Value;
        data.x_STD_MGN8 = STD_MGN8Value;
        data.x_STD_MGN9 = STD_MGN9Value;
        data.x_STD_MGN10 = STD_MGN10Value;
        data.x_STD_MGN11 = STD_MGN11Value;
        data.x_STD_MGN12 = STD_MGN12Value;
        data.x_STD_MGN13 = STD_MGN13Value;
        data.x_STD_MGN14 = STD_MGN14Value;
        data.x_STD_MGN15 = STD_MGN15Value;

        ;
        (async () => {
            try {
                //console.log("call SLSetupedit data", data)
                //console.log("call SLSetupedit isNew", isNew)
                const res = await gsb.post('/SLUser', {sb_data: data, cPgmId: "SLSetup", cAction: "SLSetupValidate", isNew: isNew})
                //console.log("SLSetupedit res.data.ok", res.data.ok)
                //console.log("SLSetupedit res.data.data", res.data.data)

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }
                    return
                }

                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()


    }



    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
                {/*<Button className="Col-2-1" icon="undo" onClick={() => reset(ac)}>Reset</Button>*/}
                {/*<Button className="Col-3-1" icon="tick" type="submit">Save</Button>*/}
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 1">
                    <InputGroup id="inputMAIM_LCN" value={MAIN_LCN1Value} onChange={utils.handleStringChange(n => setMAIN_LCN1Value(n))} inputRef={register({ maxLength: 8}) } />
                    {errors.x_MAIN_LCN1 && errors.x_MAIN_LCN1.types && <span id="Err_msg">{errors.x_MAIN_LCN1.types.message}</span>}
                    {errors.x_MAIN_LCN1 && errors.x_MAIN_LCN1.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN1"
                        inline={true}
                        selectedValue={STD_MGN1Value}
                        onChange={utils.handleStringChange(s => setSTD_MGN1Value(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.x_STD_MGN1 && errors.x_STD_MGN1.types && <span id="Err_msg">{errors.x_STD_MGN1.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 2">
                    <InputGroup id="inputMAIM_LCN" value={MAIN_LCN2Value} onChange={utils.handleStringChange(n => setMAIN_LCN2Value(n))}inputRef={register({ maxLength: 8}) } />
                    {errors.x_MAIN_LCN2 && errors.x_MAIN_LCN2.types && <span id="Err_msg">{errors.x_MAIN_LCN2.types.message}</span>}
                    {errors.x_MAIN_LCN2 && errors.x_MAIN_LCN2.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN2"
                        inline={true}
                        selectedValue={STD_MGN2Value}
                        onChange={utils.handleStringChange(s => setSTD_MGN2Value(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.x_STD_MGN2 && errors.x_STD_MGN2.types && <span id="Err_msg">{errors.x_STD_MGN2.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 3">
                    <InputGroup id="inputMAIM_LCN" value={MAIN_LCN3Value} onChange={utils.handleStringChange(n => setMAIN_LCN3Value(n))}inputRef={register({ maxLength: 8}) } />
                    {errors.x_MAIN_LCN3 && errors.x_MAIN_LCN3.types && <span id="Err_msg">{errors.x_MAIN_LCN3.types.message}</span>}
                    {errors.x_MAIN_LCN3 && errors.x_MAIN_LCN3.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN3"
                        inline={true}
                        selectedValue={STD_MGN3Value}
                        onChange={utils.handleStringChange(s => setSTD_MGN3Value(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.x_STD_MGN3 && errors.x_STD_MGN3.types && <span id="Err_msg">{errors.x_STD_MGN3.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 4">
                    <InputGroup id="inputMAIM_LCN" value={MAIN_LCN4Value} onChange={utils.handleStringChange(n => setMAIN_LCN4Value(n))}inputRef={register({ maxLength: 8}) } />
                    {errors.x_MAIN_LCN4 && errors.x_MAIN_LCN4.types && <span id="Err_msg">{errors.x_MAIN_LCN4.types.message}</span>}
                    {errors.x_MAIN_LCN4 && errors.x_MAIN_LCN4.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN4"
                        inline={true}
                        selectedValue={STD_MGN4Value}
                        onChange={utils.handleStringChange(s => setSTD_MGN4Value(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.x_STD_MGN4 && errors.x_STD_MGN4.types && <span id="Err_msg">{errors.x_STD_MGN4.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 5">
                    <InputGroup id="inputMAIM_LCN" value={MAIN_LCN5Value} onChange={utils.handleStringChange(n => setMAIN_LCN5Value(n))}inputRef={register({ maxLength: 8}) } />
                    {errors.x_MAIN_LCN5 && errors.x_MAIN_LCN5.types && <span id="Err_msg">{errors.x_MAIN_LCN5.types.message}</span>}
                    {errors.x_MAIN_LCN5 && errors.x_MAIN_LCN5.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN5"
                        inline={true}
                        selectedValue={STD_MGN5Value}
                        onChange={utils.handleStringChange(s => setSTD_MGN5Value(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.x_STD_MGN5 && errors.x_STD_MGN5.types && <span id="Err_msg">{errors.x_STD_MGN5.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 6">
                    <InputGroup id="inputMAIM_LCN" value={MAIN_LCN6Value} onChange={utils.handleStringChange(n => setMAIN_LCN6Value(n))}inputRef={register({ maxLength: 8}) } />
                    {errors.x_MAIN_LCN6 && errors.x_MAIN_LCN6.types && <span id="Err_msg">{errors.x_MAIN_LCN6.types.message}</span>}
                    {errors.x_MAIN_LCN6 && errors.x_MAIN_LCN6.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN6"
                        inline={true}
                        selectedValue={STD_MGN6Value}
                        onChange={utils.handleStringChange(s => setSTD_MGN6Value(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.x_STD_MGN6 && errors.x_STD_MGN6.types && <span id="Err_msg">{errors.x_STD_MGN6.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 7">
                    <InputGroup id="inputMAIM_LCN" value={MAIN_LCN7Value} onChange={utils.handleStringChange(n => setMAIN_LCN7Value(n))}inputRef={register({ maxLength: 8}) } />
                    {errors.x_MAIN_LCN7 && errors.x_MAIN_LCN7.types && <span id="Err_msg">{errors.x_MAIN_LCN7.types.message}</span>}
                    {errors.x_MAIN_LCN7 && errors.x_MAIN_LCN7.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN7"
                        inline={true}
                        selectedValue={STD_MGN7Value}
                        onChange={utils.handleStringChange(s => setSTD_MGN7Value(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.x_STD_MGN7 && errors.x_STD_MGN7.types && <span id="Err_msg">{errors.x_STD_MGN7.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 8">
                    <InputGroup id="inputMAIM_LCN" value={MAIN_LCN8Value} onChange={utils.handleStringChange(n => setMAIN_LCN8Value(n))}inputRef={register({ maxLength: 8}) } />
                    {errors.x_MAIN_LCN8 && errors.x_MAIN_LCN8.types && <span id="Err_msg">{errors.x_MAIN_LCN8.types.message}</span>}
                    {errors.x_MAIN_LCN8 && errors.x_MAIN_LCN8.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN8"
                        inline={true}
                        selectedValue={STD_MGN8Value}
                        onChange={utils.handleStringChange(s => setSTD_MGN8Value(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.x_STD_MGN8 && errors.x_STD_MGN8.types && <span id="Err_msg">{errors.x_STD_MGN8.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 9">
                    <InputGroup id="inputMAIM_LCN" value={MAIN_LCN9Value} onChange={utils.handleStringChange(n => setMAIN_LCN9Value(n))}inputRef={register({ maxLength: 8}) } />
                    {errors.x_MAIN_LCN9 && errors.x_MAIN_LCN9.types && <span id="Err_msg">{errors.x_MAIN_LCN9.types.message}</span>}
                    {errors.x_MAIN_LCN9 && errors.x_MAIN_LCN9.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN9"
                        inline={true}
                        selectedValue={STD_MGN9Value}
                        onChange={utils.handleStringChange(s => setSTD_MGN9Value(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.x_STD_MGN9 && errors.x_STD_MGN9.types && <span id="Err_msg">{errors.x_STD_MGN9.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 10">
                    <InputGroup id="inputMAIM_LCN" value={MAIN_LCN10Value} onChange={utils.handleStringChange(n => setMAIN_LCN10Value(n))}inputRef={register({ maxLength: 8}) } />
                    {errors.x_MAIN_LCN10 && errors.x_MAIN_LCN10.types && <span id="Err_msg">{errors.x_MAIN_LCN10.types.message}</span>}
                    {errors.x_MAIN_LCN10 && errors.x_MAIN_LCN10.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN10"
                        inline={true}
                        selectedValue={STD_MGN10Value}
                        onChange={utils.handleStringChange(s => setSTD_MGN10Value(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.x_STD_MGN10 && errors.x_STD_MGN10.types && <span id="Err_msg">{errors.x_STD_MGN10.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            { (GsbFlag.LONG_BKMGN) && <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 11">
                    <InputGroup id="inputMAIM_LCN" value={MAIN_LCN11Value} onChange={utils.handleStringChange(n => setMAIN_LCN11Value(n))}inputRef={register({ maxLength: 8}) } />
                    {errors.x_MAIN_LCN11 && errors.x_MAIN_LCN11.types && <span id="Err_msg">{errors.x_MAIN_LCN11.types.message}</span>}
                    {errors.x_MAIN_LCN11 && errors.x_MAIN_LCN11.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN11"
                        inline={true}
                        selectedValue={STD_MGN11Value}
                        onChange={utils.handleStringChange(s => setSTD_MGN11Value(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.x_STD_MGN11 && errors.x_STD_MGN11.types && <span id="Err_msg">{errors.x_STD_MGN11.types.message}</span>}
                </FormGroup>
            </div> }
            { (GsbFlag.LONG_BKMGN) && <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 12">
                    <InputGroup id="inputMAIM_LCN" value={MAIN_LCN12Value} onChange={utils.handleStringChange(n => setMAIN_LCN12Value(n))}inputRef={register({ maxLength: 8}) } />
                    {errors.x_MAIN_LCN12 && errors.x_MAIN_LCN12.types && <span id="Err_msg">{errors.x_MAIN_LCN12.types.message}</span>}
                    {errors.x_MAIN_LCN12 && errors.x_MAIN_LCN12.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN12"
                        inline={true}
                        selectedValue={STD_MGN12Value}
                        onChange={utils.handleStringChange(s => setSTD_MGN12Value(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.x_STD_MGN12 && errors.x_STD_MGN12.types && <span id="Err_msg">{errors.x_STD_MGN12.types.message}</span>}
                </FormGroup>
            </div> }
            { (GsbFlag.LONG_BKMGN) && <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 13">
                    <InputGroup id="inputMAIM_LCN" value={MAIN_LCN13Value} onChange={utils.handleStringChange(n => setMAIN_LCN13Value(n))}inputRef={register({ maxLength: 8}) } />
                    {errors.x_MAIN_LCN13 && errors.x_MAIN_LCN13.types && <span id="Err_msg">{errors.x_MAIN_LCN13.types.message}</span>}
                    {errors.x_MAIN_LCN13 && errors.x_MAIN_LCN13.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN13"
                        inline={true}
                        selectedValue={STD_MGN13Value}
                        onChange={utils.handleStringChange(s => setSTD_MGN13Value(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.x_STD_MGN13 && errors.x_STD_MGN13.types && <span id="Err_msg">{errors.x_STD_MGN13.types.message}</span>}
                </FormGroup>
            </div> }
            { (GsbFlag.LONG_BKMGN) && <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 14">
                    <InputGroup id="inputMAIM_LCN" value={MAIN_LCN14Value} onChange={utils.handleStringChange(n => setMAIN_LCN14Value(n))}inputRef={register({ maxLength: 8}) } />
                    {errors.x_MAIN_LCN14 && errors.x_MAIN_LCN14.types && <span id="Err_msg">{errors.x_MAIN_LCN14.types.message}</span>}
                    {errors.x_MAIN_LCN14 && errors.x_MAIN_LCN14.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN14"
                        inline={true}
                        selectedValue={STD_MGN14Value}
                        onChange={utils.handleStringChange(s => setSTD_MGN14Value(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.x_STD_MGN14 && errors.x_STD_MGN14.types && <span id="Err_msg">{errors.x_STD_MGN14.types.message}</span>}
                </FormGroup>
            </div> }
            { (GsbFlag.LONG_BKMGN) && <div className="Row">
                <FormGroup className="Col-1-2" label="Stock Location 15">
                    <InputGroup id="inputMAIM_LCN" value={MAIN_LCN15Value} onChange={utils.handleStringChange(n => setMAIN_LCN15Value(n))}inputRef={register({ maxLength: 8}) } />
                    {errors.x_MAIN_LCN15 && errors.x_MAIN_LCN15.types && <span id="Err_msg">{errors.x_MAIN_LCN15.types.message}</span>}
                    {errors.x_MAIN_LCN15 && errors.x_MAIN_LCN15.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                </FormGroup>
                <FormGroup className="Col-3-2" label="Standard Fin Rate">
                    <RadioGroup
                        name="x_STD_MGN15"
                        inline={true}
                        selectedValue={STD_MGN15Value}
                        onChange={utils.handleStringChange(s => setSTD_MGN15Value(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.x_STD_MGN15 && errors.x_STD_MGN15.types && <span id="Err_msg">{errors.x_STD_MGN15.types.message}</span>}
                </FormGroup>
            </div> }
            <div className="Spacing-V-16" />
        </form>
    )
}

interface SLSetupMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function SLSetupMain({ gsb }: SLSetupMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    const [data, setData] = useState([] as SLSetupInfo[])


    const [searchKey, setSearchKey] = useState("OpenDate")
    const [searchValue, setSearchValue] = useState("")

    const [showFilters, setShowFilters] = useState(false)
    const [showButton, setshowButton] = useState(false)


    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("Detail")
    const [currentAc, setCurrentAc] = useState({} as SLSetupInfo)
    const [BlankAc, setBlankAc] = useState({} as SLSetupInfo)


    const [currentMode, setCurrentMode] = useState("show")

    const [isDark, setIsDark] = useState(document.getElementById("body")?.classList.contains("bp4-dark"))

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    

    
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [userKey, setuserKey] = useState("")
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    //gsb default value
    //BlankAc.d_p_Pref = "P"



    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("SLSetupMain disp user_key: ", res.data.Flag.user_key)
                //console.log("SLSetupMain disp MULTI_MKT: ", res.data.Flag.MULTI_MKT)
                //console.log("SLSetupMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("SLSetupMain disp GsbFlag: ", GsbFlag)
                //console.log("SLSetupMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("SLSetupMain disp dateFormat: ", dateFormat)
                //console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("SLSetupMain disp GsbFlag.MULTI_MKT: ", sbFlag.MULTI_MKT)
                //console.log("SLSetupMain disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                //console.log("SLSetupMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                setuserKey(GsbFlag.user_key) ;

                //console.log("SLSetupMain isProduction: ", GsbFlag.isProduction)
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                //console.log("set StatusList: ", StatusList)

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb, currentMode])


    useEffect(() => {

        //console.log("MenuBar cardOpen01", cardOpen01)        
        if ( cardOpen01.substr(0,17) === "cardOpen01-Theme8" ) {
            document.getElementById("body")?.classList.add("bp4-dark")
            setIsDark(true)
        } else {
            document.getElementById("body")?.classList.remove("bp4-dark")
            setIsDark(false)
        }


    }, [gsb, GsbFlag, cardOpen01, currentMode])


    useEffect(() => {

        setnPage(1)
        if ( nPage > 0 ) {
            //setcPrintMode("PS")
        } 

        (async () => {
            try {
                const res = await gsb.post('/SLUser',
                    {   sb_data: {
                            by: "",
                            start: "",
                            nPage: 1,
                            limit: 0,
                            backward: false,
                            SortByName: false,
                                    filters: {
                            }
                        },
                        cPgmId: "SLSetup",
                        cAction: "ListRec",
                    });
                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentAc(res.data.data[0])
                }

                //console.log("main res.data", res.data.data)
                //console.log("main currentAc", currentAc)
                setCurrentMode("show")

                setshowButton(false)

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    const PrevRecProcess = async (SLSetup: SLSetupInfo) => {
    }

    const DeleteProcess = async (SLSetup: SLSetupInfo) => {
    }

    const NextRecProcess = async (SLSetup: SLSetupInfo) => {
    }

    const newOnSave = async (SLSetup: SLSetupInfo) => {
    }

    const editOnSave = async (SLSetup: SLSetupInfo) => {
        try {
            //console.log("call editOnSave", SLSetup)
            const res = await gsb.post('/SLUser', {sb_data: SLSetup, cPgmId: "SLSetup", cAction: "UpdateRec"})
            //showSuccess("Input Date & Time " + ac.d_inpputDate +" "+ ac.d_inpputTime + " record saved")
/*            
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
*/            
            //setCurrentAc(res.data.data)
            setCurrentAc(res.data.data[0])
            setCurrentMode("show")

        } catch (error) {
            utils.showError(error)
        }
    }



    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }

    // currentMode = show
    let detail = <SLSetupView gsb={gsb} SLSetup={currentAc} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ></SLSetupView>
    switch (currentMode) {
        case "edit":
            detail = <SLSetupEdit gsb={gsb} SLSetup={currentAc} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></SLSetupEdit>
            break
        case "new":
            detail = <SLSetupEdit gsb={gsb} SLSetup={BlankAc} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } }></SLSetupEdit>
            break
    }

    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>



    let list = <>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>    

    return (
        <>
            <form >
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>SL Setup</H3>
                    {/*
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                    */}

                    {detail}
                </Card>
            </form>
        </>
    );
}

export default SLSetupMain